/* ============================================================================
   SCRUB SETS / UNIFORM BUILDER — the Homepage prototype's split cards
   (08-d-homepage initSplit + initGifControls), Banners - Split D 4069:122336 ·
   M 4182:45441. Each card rises and unclips in, its title then copy follow;
   hover pushes the plate in; the plate drifts with the scroll (near
   parallax). The Uniform Builder plate is an animated GIF, which has no
   native pause, so the Homepage's hand-built one: freeze the frame on screen
   onto a canvas, then stop the <img> decoding (WCAG 2.2.2).
   ========================================================================== */

import { scroll } from 'https://cdn.jsdelivr.net/npm/motion@12.23.12/+esm';
import { animate, inView, hover, press, stagger, MO, state, tween, track, teardown, $, $$ } from '../10-pdp-prototype/mo.js';

const P_NEAR = 0.08;   // --mo-parallax-near (Homepage)

/* the drift outlives a Replay (it only reads the scroll), so it binds once */
let drifting = false;
function bindDrift() {
  if (drifting) return;
  drifting = true;
  $$('[data-split-card]').forEach((card) => {
    const plate = $('[data-split-plate]', card);
    scroll((p) => {
      plate.style.transform = state.reduced ? '' : `translate3d(0,${((p - 0.5) * -card.offsetHeight * P_NEAR).toFixed(2)}px,0) scale(1.06)`;
    }, { target: card, offset: ['start end', 'end start'] });
  });
}

export function armSplit() {
  $$('[data-split-card]').forEach((card, i) => {
    const plate = $('[data-split-plate]', card);
    const line = $('[data-split-line]', card);
    const items = $$('[data-split-item]', card);
    teardown.push(inView(card, () => {
      tween(card, { y: [MO.riseLg, 0], opacity: [0, 1], clipPath: ['inset(0 0 8% 0)', 'inset(0 0 0% 0)'] },
        { duration: MO.cinematic, delay: i % 2 === 0 ? 0 : MO.stagLoose, ease: MO.eEntrance });
      if (line) tween(line, { y: [MO.riseSm, 0], opacity: [0, 1] }, { duration: MO.deliberate, delay: 0.24, ease: MO.eEntrance });
      if (items.length) tween(items, { y: [MO.riseSm, 0], opacity: [0, 1] }, { duration: MO.slow, delay: stagger(MO.stagBase, { startDelay: 0.4 }), ease: MO.eEntrance });
    }, { amount: 0.25 }));
    teardown.push(hover(card, () => {
      track(animate(plate, { scale: MO.scaleIn }, { duration: MO.deliberate, ease: MO.eEntrance }));
      return () => track(animate(plate, { scale: 1 }, { duration: MO.deliberate, ease: MO.eEntrance }));
    }));
  });
  bindDrift();
  /* the lab bar's Reduced (a rebuild) holds the GIF too, not only the OS setting at load */
  if (state.reduced) gifs.forEach((g) => g.freeze());
}

let gifsBound = false;
const gifs = [];
export function initGifControls() {
  if (gifsBound) return;
  gifsBound = true;
  $$('[data-gif-toggle]').forEach((btn) => {
    const scope = btn.closest('.scard') || btn.parentElement;
    const img = $('[data-gif-plate]', scope);
    const canvas = $('[data-gif-freeze]', scope);
    if (!img || !canvas) return;
    const ctx = canvas.getContext('2d');
    const originalSrc = img.getAttribute('src');
    const icon = $('svg', btn);
    let frozen = false;
    function paint() {
      const r = img.getBoundingClientRect();
      const dpr = Math.min(2, window.devicePixelRatio || 1);
      canvas.width = Math.max(1, Math.round(r.width * dpr));
      canvas.height = Math.max(1, Math.round(r.height * dpr));
      const iw = img.naturalWidth; const ih = img.naturalHeight;
      if (!iw || !ih) { try { ctx.drawImage(img, 0, 0, canvas.width, canvas.height); } catch (e) { /* not decoded */ } return; }
      /* match the <img>'s object-fit: cover crop instead of stretching it */
      const boxRatio = canvas.width / canvas.height; const imgRatio = iw / ih;
      let sx = 0; let sy = 0; let sw = iw; let sh = ih;
      if (imgRatio > boxRatio) { sw = ih * boxRatio; sx = (iw - sw) / 2; } else { sh = iw / boxRatio; sy = (ih - sh) / 2; }
      try { ctx.drawImage(img, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height); } catch (e) { /* not decoded */ }
    }
    const setIcon = (playing) => { icon.innerHTML = playing ? '<path d="M0 0h3v12H0zM7 0h3v12H7z"/>' : '<path d="M0 0l10 6-10 6z"/>'; };
    function freeze() {
      if (frozen || !img.getAttribute('src')) return;
      paint();
      canvas.dataset.frozen = 'true';
      img.removeAttribute('src');       // actually stops the GIF decoding
      frozen = true;
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-label', 'Play animation');
      setIcon(false);
    }
    function unfreeze() {
      if (!frozen) return;
      img.setAttribute('src', originalSrc);   // restarts at frame one (the format's limit)
      canvas.dataset.frozen = 'false';
      frozen = false;
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', 'Pause animation');
      setIcon(true);
    }
    btn.addEventListener('click', () => { if (frozen) unfreeze(); else freeze(); });
    gifs.push({ freeze: () => { if (img.complete) freeze(); else img.addEventListener('load', freeze, { once: true }); } });
    press(btn, () => {
      track(animate(btn, { scale: MO.scalePress }, { duration: MO.instant, ease: MO.eStandard }));
      return () => track(animate(btn, { scale: 1 }, state.reduced ? { duration: MO.instant } : { type: 'spring', stiffness: 520, damping: 16 }));
    });
    /* Reduced motion: the GIF starts held */
    if (state.reduced) { if (img.complete) freeze(); else img.addEventListener('load', freeze, { once: true }); }
  });
}
